import { render, staticRenderFns } from "./modelEditor.vue?vue&type=template&id=43d22db2&lang=html&"
import script from "./modelEditor.vue?vue&type=script&lang=js&"
export * from "./modelEditor.vue?vue&type=script&lang=js&"
import style0 from "./modelEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports